module.exports = __webpack_public_path__ + "img/price-4550.01d13d2a.png";